import {useState, useContext} from "react";
import {  Dialog } from "@material-ui/core"
import styles from '../css/CompetencePerformanceEvaluation.module.css'
import PerformanceEvaluationContext from "../../../context/PerformanceEvaluationContext/PerformanceEvaluationContext";
import { closeEliminaPerformanceEvaluationModal } from "../../../context/PerformanceEvaluationContext/Actions";
import { DELETE_PERFORMANCE_EVALUATION,
         GET_ALL_PERFORMANCES_EVALUATION } from "../../../Querys/performanceEvaluation/querys";
import { useMutation } from "@apollo/client";

const EliminaPerformanceEvaluation = () =>{
    const {state, dispatch} = useContext(PerformanceEvaluationContext)
    const [activo, setactivo] = useState(false)
    const [deletePerformanceEval] = useMutation(DELETE_PERFORMANCE_EVALUATION, {
      fetchPolicy: 'no-cache',
      refetchQueries: [{ query: GET_ALL_PERFORMANCES_EVALUATION }],
    });

    const handleChange = (e: any) =>{ 
      if(e.target.value === 'ELIMINAR'){
          setactivo(true)
      }else{
          setactivo(false)
      }
    }

    const handleDelete = async () =>{ 
      deletePerformanceEval({
        variables:{
          id:state._id
        }
      })
      handleClose()
    }

    const handleClose = () =>{
      setactivo(false)
      closeEliminaPerformanceEvaluationModal("0",false,dispatch)
    }    

    
    return(
      <Dialog aria-labelledby='costumized-dialog-title' open={state.modalEliminaPerformanceEvaluation} fullWidth={false}  onClose={handleClose} maxWidth={"md"}>
        <div className={styles.em_container}>
          <div className={styles.contenedorCerrarModal}>
            <div 
              className={styles.cerrarModal}
              onClick={()=> handleClose()}>
            </div>
          </div>
          <div className={styles.contenedorPrincipal}>
            <div className={styles.iconoEliminar}>
            </div>
            <div className={styles.em_titulo}>
              ¿Est&aacute;s seguro de que quieres eliminar la evaluación?
            </div>
            <div className={styles.em_mensajePrtincipal}>
                <span>Una vez eliminado no podr&aacute;s recuperar la informaci&oacute;n</span>
                <br />
                <span className={styles.em_textoPrincipal}>Escribe ELIMINAR para confirmar</span>
            </div>
            <div>
              <input 
                className={styles.input}
                type="text"
                onChange={(e) => handleChange(e)}
              />
            </div>
          </div>
        </div>
        <div className={styles.em_contenedorBotones}>
              <button 
                className={styles.em_botonCancelar}
                onClick={()=> handleClose()}
              >
                Cancelar
              </button>
              {(activo === true ? 
                <button 
                  className={styles.em_botonConfirmarActivo}
                  onClick={()=> handleDelete()}
                  >
                  <div className={styles.em_iconoConfirmarEliminar}></div>
                    <div>
                      Confirmar
                    </div>
                </button>
              :
                <button className={styles.em_botonConfirmarInactivo}>
                  <div className={styles.em_iconoConfirmarEliminar}></div>
                    <div>
                      Confirmar
                    </div>
                </button>
              )}

            </div>
      </Dialog>
    )
}

export default EliminaPerformanceEvaluation